/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


$(document).ready(function() {
    
    $('.testimonial-sec-blocks').slick({
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        prevArrow:`<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.2135 2.375L2.63558 10.9529C2.23598 11.3525 2.23598 12.0004 2.63558 12.4L11.2135 20.9779" stroke="#111111" stroke-width="4.09302" stroke-linecap="round"/>
                    </svg>
                    </button>`,
        nextArrow:`<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.7887 2.375L11.3666 10.9529C11.7662 11.3525 11.7662 12.0004 11.3666 12.4L2.7887 20.9779" stroke="#111111" stroke-width="4.09302" stroke-linecap="round"/>
                    </svg></button>`,
        responsive: [
            {
                breakpoint: 999,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 740,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                    arrows:false
                }
            }
        ]
    });

    $("body").on("click", ".product-meta-share-button", function (){
        $(this).closest('.product-meta-share-block').find('.product-meta-share-modal').attr('open', '');
    })
    $("body").on("click", ".product-meta-share-button-close, .product-meta-share-overlay", function (){
        $(this).closest('.product-meta-share-block').find('.product-meta-share-modal').removeAttr('open', '');
    })
    
    var firstTitle = $(".product-form__dropdown-title").first();
    if (window.innerWidth > 768) {
        firstTitle.addClass("active");
        firstTitle.next(".product-form__dropdown-content").slideDown();
    }
    $("body").on("click", ".product-form__dropdown-title", function () {
        var activeTitle = $(this);
        activeTitle.toggleClass("active");
        var currentDropdown = activeTitle.next(".product-form__dropdown-content");
        $(".product-form__dropdown-title").not(activeTitle).removeClass("active");
        $(".product-form__dropdown-content").not(currentDropdown).slideUp();
        currentDropdown.stop(true, true).slideToggle();
    });
    $("body").on("click", ".product-offer-header", function () {
        $(this).toggleClass("active");
        $(this).next(".product-offer-content").slideToggle();
    })
    $("body").on("click", ".product-offer-code-block", function () {
        var copy_text = $(this).find('.product-offer-copy-code');
        var text = $(this).find('.product-offer-code').text();
        var $temp = $("<input>");
        
        $("body").append($temp);
        $temp.val(text).select();
        document.execCommand("copy");
        $temp.remove();
        copy_text.html('Copied');
        
        setTimeout(function () {
        copy_text.html('Copy');
        }, 1000);
    });

    $('body').on('change','.fbt-products-iner [name="fbt_items"]', function(){
        console.log($(this).is(':checked'));
        var totalprice = 0;
        var comptotalprice = 0;
        $(this).closest('.items-list-flex').find('[name="fbt_items"]').each(function(i,e){
            if($(this).is(':checked')){
                totalprice += parseInt($(this).attr('data-price'));
                comptotalprice += parseInt($(this).attr('data-compprice'));
            }
        });
        console.log(comptotalprice);
        var ttkprice = totalprice + comptotalprice;
        var pricehtml = `<div class="price-wrapper-fbt">
                            <span class="text">Total Price </span>
                            <span class="price">${window.formatMoney(ttkprice)}</span>
                        </div>
                        <div class="price-wrapper-fbt discount-price">
                            <span class="text">Discount Price </span>
                            <span class="price">${window.formatMoney(comptotalprice)}</span>
                        </div>
                        <div class="price-wrapper-fbt total-price">
                            <span class="text">Final Price </span>
                            <span class="price">${window.formatMoney(totalprice)}</span>
                        </div>`;
        $(this).closest('.fbt-iner').find('.items-total-flex').html(pricehtml);
    });
    $('body').on('click','.fbt-products-info [data-fbt-atc]', function(){
        var items = [];
        $(this).closest('.fbt-iner').find('[name="fbt_items"]').each(function(i,e){
            if($(this).is(':checked')){
                items.push({
                quantity: 1,
                id: $(this).attr('data-vid')
                })  
            }
        });
        if(items.length > 0){
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                async: false,
                data: {items},
                dataType: 'json',
                error: function(jqXHR, textStatus, errorThrown){
                var response = $.parseJSON(jqXHR.responseText);
                console.log('Free Gift Error',response.description);
                },
                success: function(cart) {
                fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
                    const cartContent = await response2.json();
                    document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
                    bubbles: true,
                    detail: {
                        cart: cartContent
                    }
                    }));
                    // cartContent["sections"] = responseJson["sections"];
                    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                    bubbles: true,
                    detail: {
                        cart: cartContent,
                        openMiniCart: true
                    }
                    }));
                    // document.getElementById('mini-cart').open = true;
                });
                
                }
            });
        }
    });

})